export const BREAKPOINT = Object.freeze({
	SMALL: 576,
	MEDIUM: 768
});
